module.exports = __webpack_public_path__ + "static/media/slider2.8482e929.png";